<template>
  <div>
    <div class="panel-body" style="border:1px solid #EFEFEF;width:282px;">
      <table style="background-color: #FFFFFF;width:360px">
        <tr>
          <td>
            {{line_name}}
          </td>
          <td>
            <div id="block_container" style="width=200px">
              <div id="bloc1" style="margin-bottom:20px;margin-top:20px;margin-left:0px;margin-right:20px">
                <p style="font-size:15px;margin-top: 4px; color:#2F4F4F;width:25px">
                  Bus
                </p>
              </div>
              <div id="bloc2" style="margin-bottom:20px;margin-top:20px;margin-left:0px;margin-right:20px;text-align: left;">
                <el-select v-model="value_bus_num" placeholder=" " size="mini" style="width:120%">
                  <el-option v-for="item in bus_num_options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <!-- <div id="bloc3" style="margin-bottom:20px;margin-top:20px;margin-left:20px;margin-right:1px">
						  <p style = "font-size:15px;margin-top: 4px; color:#2F4F4F">
							Duration
						  </p>
						</div>
						<div id="bloc4" style="margin-bottom:20px;margin-top:20px;margin-left:0px;margin-right:12px;text-align: left;">
						  <el-select v-model="value_duration" placeholder=" " size="mini" style = "width:120%">
							<el-option
							v-for="item in duration_options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						  </el-select>
						</div> -->
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <p style="font-size:15px;margin-top: 4px; color:#2F4F4F;width:80px">Index {{rate}}</p>
          </td>
          <td>
            <div id="block_container">
              <div id="bloc5">
                <p style="font-size:15px;margin-top: 4px; margin-left:0px;color:#2F4F4F">
                  Format
                </p>
              </div>
              <div id="bloc6">
                <el-select v-model="value_media_format" placeholder="Select" size="mini" style="width:100%">
                  <el-option v-for="item in media_format_options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  var bus_num_options = [];
  for (let i = 0; i <= 20; i++) {
    let obj = {
      "value": i,
      "label": i
    }
    bus_num_options.push(obj);
  }
  var duration_options = bus_num_options;

  var media_format_options = null;
  if (JSON.parse(sessionStorage.getItem('Data_Information'))) {

    media_format_options = JSON.parse(sessionStorage.getItem('Data_Information')).media_format_options;
  }
  export default {
    name: 'bus_line_info',
    props: ['line_name', 'rate', 'format_code'],
    data() {
      return {
        value_media_format: 1,
        value_bus_num: 1,
        value_duration: 1,
        bus_num_options: bus_num_options,
        duration_options: duration_options,
        media_format_options: media_format_options,
        checked: true,
      }
    },
    mounted() {
    },

    methods: {

      updateself: function() {
        this.$forceUpdate();
      },
    },


  }
</script>

<style scoped>
  #block_container {
    display: flex;
  }
</style>
